import { ContentLink } from '@api/types';
import {
  BlockContainer,
  BuyersCertificateList,
  BuyersCertificateListFilters,
  BuyersCertificateListHeader,
  BuyersCertificateListProvider,
} from '@components';

type BuyersCertificateListBlockProps = {
  contentLink?: ContentLink;
  numberItemsOnPage?: number;
  title?: string;
};

export const BuyersCertificateListBlock = ({
  contentLink,
  numberItemsOnPage,
  title,
}: BuyersCertificateListBlockProps) => {
  const id = contentLink?.id?.toString() || '';
  return (
    <BuyersCertificateListProvider id={id} numberItemsOnPage={numberItemsOnPage}>
      <BlockContainer>
        <div className='technical-list-block'>
          <BuyersCertificateListHeader title={title} />
          <BuyersCertificateListFilters />
          <BuyersCertificateList />
        </div>
      </BlockContainer>
    </BuyersCertificateListProvider>
  );
};
